import { useLayoutEffect, useRef } from 'react';
import { useDebounce } from 'react-use';
import { playSound, Sound } from '~/assets/sounds';
import { rage } from '~/rage';
import { useLayoutDispatch, useLayoutSelector } from '../../redux/hooks';
import { setSelectedColor } from '../../redux/slices/colorPickerSlice';
import { setColorPickerExpanded } from '../../redux/slices/menuPanelsSlice';
import { ColorPickerInputs } from '../ColorPickerInputs';
import { ExpandWindow } from '../ExpandWindow';
import {
	StyledColorInputsContainer,
	StyledColorPicker,
} from './ColorPicker.styled';

const ColorPicker = (props: React.HtmlHTMLAttributes<HTMLDivElement>) => {
	const sectionIndex = useLayoutSelector(
		(state) => state.colorPicker.sectionIndex,
	);
	const selectedColor = useLayoutSelector(
		(state) => state.colorPicker.selectedColor,
	);
	const expanded = useLayoutSelector(
		(state) => state.menuPanels.expanded.colorPicker,
	);
	const dispatch = useLayoutDispatch();

	useDebounce(
		() => rage.vehicleShop.setPreviewVehicleColor(selectedColor),
		250,
		[selectedColor],
	);

	const pickerWrapperRef = useRef<HTMLDivElement>(null);

	useLayoutEffect(() => {
		const interactives =
			pickerWrapperRef.current?.querySelectorAll<HTMLElement>(
				'.react-colorful__interactive',
			);
		interactives?.forEach((el) => {
			el.tabIndex = -1;
		});
	}, []);

	const currentColor = selectedColor[sectionIndex];

	return (
		<ExpandWindow
			title={'Цвет транспорта'}
			height={450}
			expanded={expanded}
			toggleExpand={() => dispatch(setColorPickerExpanded(!expanded))}
			{...props}
		>
			<div ref={pickerWrapperRef}>
				<StyledColorPicker
					color={currentColor}
					onChange={(rgbColor) => dispatch(setSelectedColor(rgbColor))}
					onMouseEnter={() => playSound(Sound.LinkCursor)}
					onKeyDown={(e) => {
						if (e.key === 'Tab') {
							e.preventDefault();
							e.stopPropagation();
						}
					}}
				/>
			</div>
			<StyledColorInputsContainer>
				<ColorPickerInputs />
			</StyledColorInputsContainer>
		</ExpandWindow>
	);
};

export { ColorPicker };
